import clsx from 'clsx'
import React from 'react'
import { BadgeOnNotification } from '@workspace/frontend-kit'
import { UserMenuItemLabelProps } from './_props'
import useStyles from './styles/UserMenuItemStyles'

const UserMenuItemLabel = ({ label, icon, displayBadge }: UserMenuItemLabelProps) => {
    const classes = useStyles()
    return (
        <div className={clsx(classes.UserMenuLink, classes.UserMenuMenuItemLabel)}>
            {icon && <span className={classes.UserMenuMenuItemLabelIcon}>{icon}</span>}
            <span
                className={clsx(classes.UserMenuMenuItemLabelText, icon && classes.UserMenuMenuItemLabelTextWithIcon)}
            >
                <BadgeOnNotification displayBadge={displayBadge}> {label} </BadgeOnNotification>
            </span>
        </div>
    )
}

export default UserMenuItemLabel
